import { faRss as faRssRegular } from "@fortawesome/pro-regular-svg-icons/faRss";
import { faRss as faRssSolid } from "@fortawesome/pro-solid-svg-icons/faRss";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

interface IProps extends Omit<MprcIconFaProps, "icon"> {
    variant: "solid" | "regular";
}

export const IconInterest: React.FC<IProps> = (props) => {
    return <MprcIconFa {...props} icon={props.variant == "regular" ? faRssRegular : faRssSolid} />;
};
